const TRUNCATION_LENGTH = 75

export const truncatedQuestion = (text: string) => {
  if (text.length <= TRUNCATION_LENGTH) return text
  return `${text.slice(0, TRUNCATION_LENGTH)}...`
}
